
<div class="input-container" v-if="type === 'text'">
    <label v-if="show_label" :for="field.title">{{ field.title }}:</label>
    <input type="text" :id="field.label"  v-model="inputValue" @input="verifyInput" :placeholder=" (field && field.placeholder) ? field.placeholder : '' " :disabled="disableInput"
    :maxlength="field.max_length"/>
</div>
<div class="input-container" v-else-if="type === 'number'">
    <label v-if="show_label" :for="field.title">{{ field.title }}:</label>
    <input type="number" :id="field.label"  v-model="inputValue" :placeholder=" (field && field.placeholder) ? field.placeholder : ''" :disabled="disableInput"/>
</div>
<div class="input-container" v-else-if="type === 'phone'">
    <label v-if="show_label" :for="field.title">{{ field.title }}:</label>
    <div class="phone-input">
        <VuePhoneNumberInput
          v-model="phone"
          :no-example="true"
          size="lg"
          :translations="translations"
          @update="setPhoneValue"
          :color="'#7c7c7c'"
          :border-radius="10"
          default-country-code="MX"
          :preferred-countries="['MX', 'US']"
          :disabled="disableInput"
          :no-country-selector="noCountrySelector"
        />
    </div>
</div>
<div class="checkbox-input" v-else-if="type === 'checkbox'">
    <input type="checkbox" :id="field.title"  v-model="inputValue" :disabled="disableInput" />
    <label :for="field.title" v-html="field.help"></label>
</div>
<div class="input-container select-input" v-else-if="type === 'select'">
    <label v-if="show_label" :for="field.title">{{ field.title }}:</label>
    <select :id="field.label" v-model="inputValue" :disabled="disableInput">
        <option v-for="option in selectOptions" :key="option" :value="option">{{ option }}</option>
    </select>
</div>
